import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IoMdHome } from 'react-icons/io';
import { MdOutlineLogout } from 'react-icons/md';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';

const Layout = ({ children, title }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const [show, setSidebar] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleResize = () => {
    if (window.innerWidth >= 1024) {
      setMobileSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const closeMobileSidebar = () => {
    setMobileSidebar(false);
  };

  const AdminSidebarOptions = () => (
    <div className={`
      fixed top-0 z-40 w-full lg:w-[calc(100%-var(--sidebar-width))] 
      flex bg-gradient-to-r from-blue-700 to-blue-600 rounded-b-lg p-2 
      justify-between items-center shadow-md
    `}>
      {/* Left: Mobile Toggle and Title */}
      <div className="flex items-center">
        <button
          onClick={() => setMobileSidebar(!mobileSidebar)}
          className="lg:hidden p-1 mr-2 rounded-full text-blue-100 hover:text-white hover:bg-blue-600 focus:outline-none"
        >
          {mobileSidebar ? <FaTimes size={20} /> : <FaBars size={20} />}
          <span className="sr-only">Toggle Sidebar</span>
        </button>
        <h1 className="text-lg font-semibold text-white truncate px-2">{title}</h1>
      </div>

      {/* Right: Profile and Logout */}
      <div className="flex items-center space-x-3">
        <img
          className="w-8 h-8 rounded-full cursor-pointer border-2 border-blue-300"
          src={user?.profileImage || '/default-avatar.jpg'}
          alt="admin avatar"
        />
        <MdOutlineLogout
          size={20}
          className="cursor-pointer text-blue-100 hover:text-white"
          onClick={handleLogout}
        />
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen" style={{ 
      '--sidebar-width': show ? '16rem' : '5rem' 
    }}>
      {/* Mobile and Desktop Sidebar */}
      <div className={`
        ${mobileSidebar 
          ? 'fixed inset-0 z-50 w-full bg-white' 
          : 'hidden lg:block fixed top-0 h-full bg-white'
        } 
        transition-all duration-300 
        ${show && !mobileSidebar ? 'w-64' : 'w-full lg:w-20'}
        shadow-md overflow-y-auto
      `}>
        <Sidebar 
          show={mobileSidebar ? true : show} 
          setSidebar={setSidebar} 
          mobileSidebar={mobileSidebar}
          closeMobileSidebar={closeMobileSidebar}
        />
      </div>

      {/* Main Content */}
      <div className={`
        flex flex-col min-h-screen w-full overflow-hidden 
        transition-all duration-300 
        ${mobileSidebar 
          ? 'opacity-0 pointer-events-none' 
          : 'opacity-100 ml-0 lg:ml-[var(--sidebar-width)]'
        }
      `}>
        <AdminSidebarOptions />
        {/* Scrollable Content */}
        <div className="pt-16 flex-1 p-6">
          {children}
        </div>
      </div>

      {/* Overlay for mobile sidebar */}
      {mobileSidebar && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={closeMobileSidebar}
        />
      )}
    </div>
  );
};

export default Layout;

